/*
 * @Author: Hugo
 * @Date: 2020-10-14 17:11:06
 * @LastEditTime: 2021-01-12 20:22:47
 * @LastEditors: Please set LastEditors
 * @Description: 元数据树的数据处理模型
 * @FilePath: /Workbench_Front_Support/src/workbench_front/pages/ZoneSetting/metatree/MetaTreeModel.js
 */
import Tree from '../../../common/models/Tree';
import Node from '../../../common/models/Node';
import TreeModel from '../../../common/models/TreeModel';
export default class MetaTreeModel extends TreeModel {
    constructor(data) {
        super(data)
    }
    /**
     * 获取树结构数据
     */
    // getMetaTreeData() {
    //     let root = this.getRoot();
	// 	return root.data;
    // }
    getMetaTreeData() {
        let root = this.getRoot();
        let serializeTree = MetaTreeModel.serialize(this);
        let allNodes = serializeTree.nodes.reverse();
        let map = new Map();
        allNodes.forEach(node => {
            let { data, children } = node;
            if (children && children.length > 0) {
                children = children.map(child => {
                    return map.get(child.data.myUniqID);
                });
                map.set(data.myUniqID, {
                    ...data,
                    children
                })
            } else {
                map.set(data.myUniqID, data);
            }
        });
        let ret = map.get(root.data.myUniqID);
        // console.log(ret);
        return ret;

    }
    /**
     * 快速创建大数据树
     * @param {Array} arr 序列化后的节点数组
     * @param {Function} getMainKeyFn 获取节点主键值
     * @param {Function} getParentKeyFn 获取父节点主键
     */
    static createBigTree(arr, getMainKeyFn, getParentKeyFn) {
        if (!arr || arr.length === 0) {
            console.error(new Error('Cannot create tree'));
            return null;
        }
        if (!getMainKeyFn || !getParentKeyFn) {
            console.error(new Error('getMainKeyFn, getParentKeyFn cannot be undefined'));
        }
        let map = new Map();
        let tree = null;
        let root = null;
        // 第一次全量遍历节点，找出根节点，并初始化所有节点实例
        // console.time('traverseAndInitAllNodes');
        arr.forEach(item => {
            if (!getParentKeyFn(item)) {
                tree = new MetaTreeModel(item);
                root = tree.getRoot();
                map.set(getMainKeyFn(item), root)
            } else {
                let node = new Node(item);
                map.set(getMainKeyFn(item), node);
            }
        });
        // console.timeEnd('traverseAndInitAllNodes');
        // 第二次遍历map表，进行子节点的插入操作
        // console.time('createTree');
        // console.log(map.size);
        map.forEach((node, key, mapObj) => {
            let id = getMainKeyFn(node.data);
            let pid = getParentKeyFn(node.data);
            if (id !== getMainKeyFn(root.data)) {
                // 指定节点的父节点
                let pNode = mapObj.get(pid);
                node.parent = pNode;
                // 父节点中的children中加入当前节点
                pNode.children.push(node);
            }
        });
        // console.timeEnd('createTree');
        return tree;
    }
}
